import type { VenueDetail } from './types';

export const mockVenues: VenueDetail[] = [
  {
    id: 'VEN001',
    name: '北京总部办公区',
    address: {
      province: '北京市',
      city: '北京市',
      district: '朝阳区',
      detail: '建国路88号SOHO现代城A座15层'
    },
    status: 'enabled',
    tenantName: '科技有限公司',
    tenantId: 'TEN001',
    thinClientCount: 12,
    area: 500,
    description: '总部主要办公区域，配备高性能云桌面设备',
    enabledTime: '2024-01-15 09:00:00',
    createdAt: '2024-01-10 14:30:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-20 16:45:00',
    updatedBy: '李运维',
    thinClients: [
      {
        id: 'TC001',
        name: '会议室-01',
        serialNumber: 'SN20240001',
        status: 'running',
        mac: '00:1A:2B:3C:4D:5E',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:30:00'
      },
      {
        id: 'TC002',
        name: '工位-A01',
        serialNumber: 'SN20240002',
        status: 'idle',
        mac: '00:1A:2B:3C:4D:5F',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:35:00'
      },
      {
        id: 'TC003',
        name: '工位-A02',
        serialNumber: 'SN20240003',
        status: 'running',
        mac: '00:1A:2B:3C:4D:60',
        firmwareVersion: 'v2.3.0',
        lastBootTime: '2024-01-25 08:32:00'
      }
    ]
  },
  {
    id: 'VEN002',
    name: '上海分公司',
    address: {
      province: '上海市',
      city: '上海市',
      district: '浦东新区',
      detail: '陆家嘴环路1000号恒生银行大厦20层'
    },
    status: 'enabled',
    tenantName: '互联网科技',
    tenantId: 'TEN002',
    thinClientCount: 8,
    area: 350,
    description: '上海分公司办公区',
    enabledTime: '2024-02-01 10:00:00',
    createdAt: '2024-01-28 11:20:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-05 14:30:00',
    updatedBy: '赵运维',
    thinClients: [
      {
        id: 'TC004',
        name: '前台接待',
        serialNumber: 'SN20240004',
        status: 'running',
        mac: '00:1A:2B:3C:4D:61',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 07:45:00'
      },
      {
        id: 'TC005',
        name: '工位-B01',
        serialNumber: 'SN20240005',
        status: 'idle',
        mac: '00:1A:2B:3C:4D:62',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:00:00'
      }
    ]
  },
  {
    id: 'VEN003',
    name: '深圳研发中心',
    address: {
      province: '广东省',
      city: '深圳市',
      district: '南山区',
      detail: '科技园南区深圳湾科技生态园5栋A座'
    },
    status: 'enabled',
    tenantName: '科技有限公司',
    tenantId: 'TEN001',
    thinClientCount: 20,
    area: 800,
    description: '研发中心，配备高性能GPU云桌面',
    enabledTime: '2024-01-20 09:00:00',
    createdAt: '2024-01-15 10:00:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-22 15:20:00',
    updatedBy: '李运维',
    thinClients: [
      {
        id: 'TC006',
        name: '研发-01',
        serialNumber: 'SN20240006',
        status: 'running',
        mac: '00:1A:2B:3C:4D:63',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:15:00'
      }
    ]
  },
  {
    id: 'VEN004',
    name: '杭州办事处',
    address: {
      province: '浙江省',
      city: '杭州市',
      district: '西湖区',
      detail: '文三路90号东部软件园E座12层'
    },
    status: 'disabled',
    tenantName: '云计算服务',
    tenantId: 'TEN003',
    thinClientCount: 5,
    area: 200,
    description: '杭州办事处',
    enabledTime: '2024-01-10 09:00:00',
    createdAt: '2024-01-05 14:00:00',
    createdBy: '刘管理员',
    updatedAt: '2024-01-24 10:30:00',
    updatedBy: '陈运维',
    thinClients: []
  },
  {
    id: 'VEN005',
    name: '成都分公司',
    address: {
      province: '四川省',
      city: '成都市',
      district: '高新区',
      detail: '天府大道中段1366号天府软件园D区5栋'
    },
    status: 'enabled',
    tenantName: '互联网科技',
    tenantId: 'TEN002',
    thinClientCount: 15,
    area: 600,
    description: '成都分公司办公区',
    enabledTime: '2024-02-10 09:00:00',
    createdAt: '2024-02-05 11:30:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-12 16:00:00',
    updatedBy: '赵运维',
    thinClients: [
      {
        id: 'TC007',
        name: '工位-C01',
        serialNumber: 'SN20240007',
        status: 'running',
        mac: '00:1A:2B:3C:4D:64',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:20:00'
      },
      {
        id: 'TC008',
        name: '工位-C02',
        serialNumber: 'SN20240008',
        status: 'idle',
        mac: '00:1A:2B:3C:4D:65',
        firmwareVersion: 'v2.3.0',
        lastBootTime: '2024-01-25 08:25:00'
      }
    ]
  },
  {
    id: 'VEN006',
    name: '广州办公区',
    address: {
      province: '广东省',
      city: '广州市',
      district: '天河区',
      detail: '珠江新城花城大道85号高德置地春广场A座18层'
    },
    status: 'enabled',
    tenantName: '云计算服务',
    tenantId: 'TEN003',
    thinClientCount: 10,
    area: 450,
    description: '广州办公区',
    enabledTime: '2024-01-25 09:00:00',
    createdAt: '2024-01-20 13:00:00',
    createdBy: '刘管理员',
    updatedAt: '2024-01-26 11:20:00',
    updatedBy: '陈运维',
    thinClients: [
      {
        id: 'TC009',
        name: '会议室-02',
        serialNumber: 'SN20240009',
        status: 'running',
        mac: '00:1A:2B:3C:4D:66',
        firmwareVersion: 'v2.3.1',
        lastBootTime: '2024-01-25 08:10:00'
      }
    ]
  }
];

export const mockTenants = [
  { id: 'TEN001', name: '科技有限公司' },
  { id: 'TEN002', name: '互联网科技' },
  { id: 'TEN003', name: '云计算服务' },
  { id: 'TEN004', name: '数据科技' },
  { id: 'TEN005', name: '智能科技' }
];

export const mockCreators = [
  { id: 'USER001', name: '张管理员' },
  { id: 'USER002', name: '王管理员' },
  { id: 'USER003', name: '刘管理员' },
  { id: 'USER004', name: '李运维' },
  { id: 'USER005', name: '赵运维' },
  { id: 'USER006', name: '陈运维' }
];
